import { createApi } from "@reduxjs/toolkit/query/react";
import { DynamicBaseQuery } from "./baseQuery";
import { SuccessResponse } from "./types/common/responses/SuccessResponse";
import { SyncOfflineDataRequest } from "./types/offline/requests/SyncOfflineDataRequest";
import { OfflineRequestStatusResponse } from "./types/offline/responses/OfflineRequestStatusResponse";
import { staticFormsApi } from "./staticFormsApi";

export const offlineApi = createApi({
  reducerPath: "offlineApi",
  baseQuery: DynamicBaseQuery,
  tagTypes: ["OfflineMode"],
  endpoints: (builder) => ({
    syncOfflineData: builder.mutation<SuccessResponse, SyncOfflineDataRequest>({
      query: (body) => ({
        url: "/sync-offline-data",
        method: "POST",
        body,
      }),
    }),
    getOfflineRequestsStatus: builder.query<
      OfflineRequestStatusResponse,
      { requestId?: number } | void
    >({
      query: (arg) => {
        const requestId = arg?.requestId;
        return {
          url: `/offline-requests-status${requestId ? `?filter[request_id]=${requestId}` : ""}`,
          method: "GET",
        };
      },
      onQueryStarted: async (_, { dispatch, queryFulfilled }) => {
        await queryFulfilled.catch(() => {});
        dispatch(
          staticFormsApi.util.invalidateTags([
            "FluidEntries",
            "BowelEntries",
            "FluidOutputEntries",
          ]),
        );
      },
    }),
  }),
});
export const {
  useSyncOfflineDataMutation,
  useLazyGetOfflineRequestsStatusQuery,
} = offlineApi;
